import { store } from 'store'
import { FETCH_NETWORKS_DATA } from 'modules/Services/NetworksList/store/types'

/**
 * Start /v1/networks as soon as services/list domain is injected (before page chunk mounts).
 */
export const prefetchServicesNetworksList = (params = {}) => {
  const slice = store.getState()['services/list']

  if (!slice || slice.loaded || slice.loading) {
    return
  }

  store.dispatch({
    type: FETCH_NETWORKS_DATA,
    payload: { params },
  })
}
